module.exports = "pegasus/assets/themelp1/simple/106.png";